//Install
import React, { Component } from "react";
//Install
import { Row, Col } from "react-bootstrap";
//Install
import T03Q5A from "../../../../../Media/Image/017.jpg";

//Element
class Q6U600 extends Component {
    //Element
    render() {
        //Element
        const Content = React.createElement("a", { className: "S6pt64 C96Q4r pEO064 a527eB v725gm", href: "/az/layiheler" },
            //Element
            React.createElement(Row, {},
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("picture", { className: "S6pt64 C96Q4r pEO064 a527eB n02a9p" },
                        //Element
                        React.createElement("img", { alt: "Təhsil Müəssisələri", title: "Təhsil Müəssisələri", src: T03Q5A, width: "306", height: "auto" })
                    )
                ),
                //Element
                React.createElement(Col, { md: 6 },
                    //Element
                    React.createElement("div", { className: "S0u16d C96Q4r g1aS48 d721Vx pEO064 a527eB z3630j" },
                        //Element
                        React.createElement("h4", { className: "S6pt64 C96Q4r pEO064 a527eB u50e58" },
                            //Element
                            "Təhsil Müəssisələri"
                        ),
                        //Element
                        React.createElement("span", { className: "S6pt64 C96Q4r pEO064 a527eB q8913p" },
                            //Element
                            "6"
                        )
                    )
                )
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Q6U600;